import Form from 'JS/form/Form';
import { notice } from 'JS/utils/notice';
import ContentProduct from '../../../components/woocommerce/product-card/_index';
import { UrlManager } from 'JS/utils/UrlManager';

export default class FiltersController {

    filter;

    /**
     * @type {UrlManager}
     */
    UrlManager;

    /**
     * @type {HTMLElement}
     */
    resetButton;

    /**
     * @type {Form}
     */
    filtersForm;

    /**
     * @type {HTMLElement}
     */
    productsWrap;

    /**
     * Selected attributes
     * 
     * @type {Record<string, string[]>}
     */
    attrs = {};

    taxQuery;

    _selectedCount = 0;

    get selectedCount() {
        return this._selectedCount;
    }

    set selectedCount(value) {
        this._selectedCount = value;
        this.onSelectedCountChange();
    }

    _sortType;

    get sortType() {
        return this._sortType;
    }

    set sortType(value) {
        if (value === this.sortType) {
            return;
        }

        this._sortType = value;
        this.onSortChange();
    }

    _productCat;

    get productCat() {
        return this._productCat;
    }

    set productCat(value) {
        if (value === this._productCat) {
            return;
        }

        this._productCat = value;
        this.onCategoryChange();
    }

    _paged;

    get paged() {
        return this._paged;
    }

    set paged(value) {
        if (value === this._paged) {
            return;
        }

        this._paged = value;
        this.onPagedChange();
    }

    isWaitingReset = false;

    filterInstance;

    constructor(filter, filterInstance) {
        if (!filter) {
            return;
        }
        this.filterInstance = filterInstance;
        this.filter = filter;
        this.productsWrap = document.querySelector('[data-products-wrap]');
        this.applyButton = this.filter.querySelector('[data-apply-filters]');
        this.resetButton = this.filter.querySelector('[data-reset-filters]');
        this.filterBtn = this.filter.querySelector('[data-filter="filters"]');
        this.mobFilterBtn = this.filter.querySelector('.product-filters-mobile__controller-btn');
        this.UrlManager = new UrlManager();
        this.init();
    }

    init() {
        this.initForm();
        this.findLoopQuery();
        this.addListeners();
    }

    addListeners() {
        document.addEventListener('DOMContentLoaded', () => {
            const checked_attrs = this.filter.querySelectorAll('input[type="checkbox"]:checked');
            if (checked_attrs) {
                this.selectedCount = checked_attrs.length;
            }
        })

        this.resetButton.addEventListener('click', () => {
            if (this.filtersForm) {
                this.filtersForm.reset();
                this.filter.querySelectorAll('input[type="checkbox"]').forEach(elm => {
                    elm.checked = false;
                });
                this.isWaitingReset = true;
            }
        });

        this.applyButton.addEventListener('click', () => {
            const url_params = [
                {
                    param: 'f_color',
                    value: this.attrs['pa_color']
                },
                {
                    param: 'f_size',
                    value: this.attrs['pa_size']
                }
            ];

            this.UrlManager.setUrlParams(url_params, true);

            //if (this.selectedCount) {
                this.sendRequest(true);
            //}
        });
    }

    findLoopQuery() {
        const script = document.querySelector('[data-loop-query]');

        if (!script) {
            return;
        }

        try {
            const parsed = JSON.parse(script.textContent);
            this.taxQuery = parsed.tax_query;
            this._paged = parsed.paged; 
        } catch(error) {
            console.warn(error);
        }
    }

    initForm() {
        const formEl = this.filter.querySelector('[data-product-filters]');
        this.filtersForm = new Form(formEl);

        // Set default sort value
        this._sortType = this.filtersForm.fields.find(f => f.name === 'sort_type')?.value;
        // Set default category value
        this._productCat = this.filtersForm.fields.find(f => f.name === 'product_cat')?.value;

        if (this.filtersForm) {
            this.filtersForm.on('change', (formData) => {
                this.onFormChange(formData);
            });
        }

        this.onSelectedCountChange();
    }

    sendRequest(closeFilters = false) {
        if (this.isPending) {
            return;
        }

        if (this.filterInstance.type === 'desktop' && window.innerWidth < 768) {
            return;
        }

        if (this.filterInstance.type === 'mobile' && window.innerWidth >= 768) {
            return;
        }

        if (!this.productsWrap) {
            return;
        }

        if (closeFilters) {
            this.filterInstance.closeFilters();
        }

        if (this.isWaitingReset) {
            ['f_sort', 'f_cat', 'f_color', 'f_size'].forEach(item => {
                this.UrlManager.removeUrlParam(item);
            })
            this.isWaitingReset = false;
            this.filterInstance.closeFilters();
        }

        this.productsWrap.classList.add('loading');
        this.filtersForm.formElement.classList.add('loading');
        this.scrollToTop();

        if (this.requestTimer) {
            clearTimeout(this.requestTimer);
        }

        this.requestTimer = setTimeout(() => {
            const data = {
                sort: this.sortType,
                attrs: this.attrs,
                tax_query: this.taxQuery,
                product_cat: this.productCat,
                paged: this.paged,
            };
    
            const params = new URLSearchParams({
                data: JSON.stringify(data),
            }).toString();

            fetch(`${backendData.restUrl}hml/v1/products?${params}`)
                .then(response => response.json())
                .then(resp => {
                    const { data, success } = resp;

                    if (success) {
                        this.productsWrap.innerHTML = data.posts ?? '';
                        this.initProductsAfterLoad();

                        
                        this.replacePagination(data.pagination ?? '');
                        
                    } else {
                        notice(data?.error ?? 'Что-то пошло не так...', 'error');
                    }
                })
                .catch(error => {
                    notice(error, 'error');
                })
                .finally(() => {
                    this.isPending = false;
                    this.productsWrap.classList.remove('loading');
                    this.filtersForm.formElement.classList.remove('loading');
                });
        }, 300); 
    }

    initProductsAfterLoad() {
        Array.from(document.querySelectorAll('.product-card')).forEach(p => {
            if (p.inited) {
                return;
            }
    
            new ContentProduct(p);
        });
    }

    replacePagination(paginationHTML = '') {
       
        const pagination = document.querySelector('.woocommerce-pagination');

        if (!pagination) {
            return;
        }

        const el = document.createElement('div');

        el.classList.add('woocommerce-pagination');
        el.innerHTML = paginationHTML;

        pagination.replaceWith(el);
        window.initPaginations();
    }

    /**
     * Calculate count of chosen options
     * 
     * @param {*} data 
     */
    onFormChange(data) {
        let count = 0;
        
        Object.keys(data).forEach((key) => {
            if (!key.includes('pa_')) {
                return;
            }

            if (!data[key]) {
                data[key] = [];
            }

            if (!Array.isArray(data[key])) {
                data[key] = [data[key]];
            }

            count += data[key].length;
        });

        this.selectedCount = count;
        
        // Get data from form
        const { 
            sort_type,
            product_cat,
            _wpnonce, 
            _wp_http_referer, 
            ...attrs 
        } = data;

        const url_params = [
            {
                param: 'f_sort',
                value: sort_type
            },
            {
                param: 'f_cat',
                value: product_cat
            }
        ];

        this.UrlManager.setUrlParams(url_params, true, product_cat != 'all');

        this.productCat = product_cat;
        this.sortType = sort_type;
        this.attrs = attrs;

        this._paged = 1;
        
        // Force send request after form change
        if (this.isWaitingReset) {
            this.sendRequest();
        }
    }

    /**
     * Change data attr of button filters
     * to display count of chosen options
     */
    onSelectedCountChange() {
        [
            this.filterBtn,
            this.mobFilterBtn,
        ].forEach(btn => {
            if (!btn) {
                return;
            }
            btn.dataset.count = this.selectedCount;
            btn.classList.toggle('count-shown', !!this.selectedCount);
        });
        

        //this.applyButton.disabled = !this.selectedCount;   
        this.applyButton.dataset.count = this.selectedCount ? `(${this.selectedCount})` : '';
        this.applyButton.classList.toggle('show-count', this.selectedCount > 0);
    }

    /**
     * Fires when sort type has been changed
     */
    onSortChange() {
        this.sendRequest();
    }

    /**
     * Fires when paged param has been changed
     */
    onPagedChange() {
        this.sendRequest(true);
    }

    /**
     * Fires when category has been changed
     */
    onCategoryChange() {
        this.sendRequest(true);
    }

    scrollToTop() {
        const scrollTop = document.documentElement.scrollTop;
        const elTop = this.productsWrap.getBoundingClientRect().top;

        const headerContent = document.querySelector('.header__content');
        const headerShopOptions = document.querySelector('.header__shop-options');

        let top = [headerContent, headerShopOptions].reduce((prev, current) => {
            return prev + (current.clientHeight ? current?.clientHeight : 0);
        }, -0);

        if (this.filterInstance.type === 'mobile') {
            top += document.querySelector('.product-filters-mobile')?.clientHeight;
        }

        window.scrollTo({
            top: scrollTop + elTop - top,
            behavior: 'smooth',
        });
    }
}
